











import {Vue, Component, Prop} from 'vue-property-decorator';
import {SelectableServiceLogDTO} from "@/components/payroll/business/services/ServiceDTO";
import ServiceView from "@/components/payroll/business/services/ServiceView.vue";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import ServiceLogView from "@/components/payroll/business/services/ServiceLogView.vue";

@Component({
	components: {ServiceLogView, PortalCheckbox, ServiceView}
})
export default class SelectableServiceLog extends Vue {

	@Prop()
	private log!: SelectableServiceLogDTO

}
